import useTrackNativePrintEvents from "./useTrackNativePrintEvents";
import useTrackGtmAccountLogin from "./useTrackGtmAccountLogin";

const GlobalEventsHandler = () => {
  useTrackNativePrintEvents();
  useTrackGtmAccountLogin();
  return null;
};

export default GlobalEventsHandler;
